import { apiRequest } from './api';
import { DispositivoRede } from './dispositivoRedeService';

export type RedeDiagramaEntidadeTipo = 'dispositivo_rede' | 'ftth_olt' | 'server_nas';

export type RedeDiagramaPortId = 'top' | 'right' | 'bottom' | 'left';

export type RedeDiagramaMonitorStatus = 'online' | 'offline' | 'unknown';

export interface RedeDiagramaNode {
  entidade_tipo: RedeDiagramaEntidadeTipo;
  entidade_id: number;
  node_id: string;
  nome: string;
  ip?: string | null;
  tipo_label: string;
  monitor_status: RedeDiagramaMonitorStatus;
  nativo: boolean;
  pos_x?: number | null;
  pos_y?: number | null;
  dispositivo?: DispositivoRede;
  olt?: {
    id: number;
    name: string;
    vendor: string;
    model: string;
    ip_address: string;
    status: string;
  };
  nas?: {
    id: number;
    nasname: string;
    shortname?: string;
    type: string;
  };
}

export interface RedeDiagramaConexao {
  id: number;
  origem_tipo: RedeDiagramaEntidadeTipo;
  origem_id: number;
  destino_tipo: RedeDiagramaEntidadeTipo;
  destino_id: number;
  origem_port?: RedeDiagramaPortId | null;
  destino_port?: RedeDiagramaPortId | null;
  rotulo?: string | null;
  style_color: string;
  style_width: number;
  ativo: boolean;
}

export interface RedeDiagramaPayload {
  nodes: RedeDiagramaNode[];
  conexoes: RedeDiagramaConexao[];
}

export interface CreateConexaoPayload {
  origem_tipo: RedeDiagramaEntidadeTipo;
  origem_id: number;
  destino_tipo: RedeDiagramaEntidadeTipo;
  destino_id: number;
  origem_port?: RedeDiagramaPortId;
  destino_port?: RedeDiagramaPortId;
  rotulo?: string;
}

export interface UpdateConexaoPortasPayload {
  origem_port: RedeDiagramaPortId;
  destino_port: RedeDiagramaPortId;
}

export interface SavePosicaoPayload {
  entidade_tipo: RedeDiagramaEntidadeTipo;
  entidade_id: number;
  pos_x: number;
  pos_y: number;
}

export const redeDiagramaService = {
  getDiagrama: async (): Promise<RedeDiagramaPayload> => {
    const response = await apiRequest.get<RedeDiagramaPayload>('/monitoramento/rede-diagrama');
    return response.data!;
  },

  createConexao: async (payload: CreateConexaoPayload): Promise<RedeDiagramaConexao> => {
    const response = await apiRequest.post<RedeDiagramaConexao>(
      '/monitoramento/rede-diagrama/conexoes',
      payload
    );
    return response.data!;
  },

  removeConexao: async (id: number): Promise<void> => {
    await apiRequest.delete(`/monitoramento/rede-diagrama/conexoes/${id}`);
  },

  updateConexaoPortas: async (
    id: number,
    payload: UpdateConexaoPortasPayload
  ): Promise<RedeDiagramaConexao> => {
    const response = await apiRequest.put<RedeDiagramaConexao>(
      `/monitoramento/rede-diagrama/conexoes/${id}/portas`,
      payload
    );
    return response.data!;
  },

  savePosicoes: async (posicoes: SavePosicaoPayload[]): Promise<void> => {
    await apiRequest.put('/monitoramento/rede-diagrama/posicoes', { posicoes });
  },
};
